import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const DeleteConfirmModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="delete-modal-body text-center">

        {/* ICON BOX */}
        <div className="delete-icon-box">
          <FiTrash2 size={28} />
        </div>

        {/* TITLE */}
        <h4 className="delete-title">Confirm Delete</h4>

        {/* DESCRIPTION */}
        <p className="delete-text">
          You want to delete all the marked items, this cant be undone once you delete.
        </p>

        {/* BUTTONS */}
        <div className="delete-actions">
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>

          <Button className="btn-delete border border-1" onClick={handleDelete}>
            Yes, Delete
          </Button>
        </div>

      </Modal.Body>
      <style>
          {
               `
               .delete-modal-body {
  padding: 30px 20px;
}

/* ICON BOX */
.delete-icon-box {
  width: 70px;
  height: 70px;
  background: #ffe5e5;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  color: #ff3b3b;
}

/* TITLE */
.delete-title {
  font-weight: 600;
  margin-bottom: 10px;
}

/* TEXT */
.delete-text {
  color: #6c757d;
  font-size: 14px;
  max-width: 300px;
  margin: 0 auto 20px;
}

/* BUTTONS */
.delete-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

/* CANCEL */
.btn-cancel {
  background: #e5e7eb !important;
  border: none !important;
  color: #333 !important;
  padding: 8px 18px;
  border-radius: 6px;
}

/* DELETE */
.btn-delete {
  background: #ff1a1a !important;
  border: none !important;
  padding: 8px 18px;
  border-radius: 6px;
}`
          }
      </style>
    </Modal>
  );
};

export default DeleteConfirmModal;